<div class="main-container" (click)="closeTestMenu()">
  <div class="header-section">
    <div class="section-title">
      Tests
    </div>
    <div class="section-actions">
      <button class="btn-create-test" (click)="onCreateTestClick()">
        <img src="assets/icons/playground-create-test.svg" alt="create-test">
      </button>
    </div>
  </div>
  <div class="body-section">
    <!-- Loading state -->
    <app-taxonomy-stack-loader *ngIf="isLoading()"></app-taxonomy-stack-loader>

    <!-- No taxonomies state -->
    <div class="no-taxonomies" *ngIf="!isLoading() && taxonomies().length === 0">
      <div class="no-taxonomies-card">
        <img src="assets/icons/playground/test_no_data.svg" alt="No Taxonomies">
        <span class="no-taxonomies-text">No taxonomies found</span>
      </div>
    </div>

    <!-- Taxonomy Tests Container -->
    <div class="taxonomy-container" *ngFor="let taxonomy of taxonomies()">
      <div class="taxonomy-title" (click)="toggleTaxonomy(taxonomy.taxonomy_id)">
        <div class="title-section">
          <img
            [src]="isTaxonomyExpanded(taxonomy.taxonomy_id) ? 'assets/icons/playground/keyboard_arrow_down.svg' : 'assets/icons/playground/keyboard_arrow_right.svg'"
            [alt]="isTaxonomyExpanded(taxonomy.taxonomy_id) ? 'keyboard_arrow_down' : 'keyboard_arrow_right'"
            class="expand-icon">
          <span class="taxonomy-name">{{ taxonomy.taxonomy_name }}</span>
        </div>
      </div>

      <div class="taxonomy-tests" *ngIf="isTaxonomyExpanded(taxonomy.taxonomy_id)">
        <!-- Loading test cards -->
        <app-test-card-loader *ngIf="isLoadingTests().has(taxonomy.taxonomy_id)" [count]="3"></app-test-card-loader>

        <!-- If no tests are found -->
        <div class="no-tests" *ngIf="!isLoadingTests().has(taxonomy.taxonomy_id) && taxonomy.test.length === 0"
          [class.selected]="selectedTest()?.taxonomyId === taxonomy.taxonomy_id && selectedTest()?.testId === 'no-tests'"
          (click)="onNoTestsClick(taxonomy.taxonomy_id)">
          <div class="no-test-card">
            <img src="assets/icons/playground/test_no_data.svg" alt="No Tests">
            <span class="no-tests-text">No tests found</span>
          </div>
        </div>

        <!-- If tests are available -->
        <div class="test-card" *ngFor="let test of taxonomy.test"
          [class.test-menu-open]="openTestMenuId() === test.test_id"
          [class.selected]="selectedTest()?.taxonomyId === taxonomy.taxonomy_id && selectedTest()?.testId === test.test_id"
          (click)="onTestCardClick(taxonomy.taxonomy_id, test.test_id)">
          <div class="title">
            <img class="test-status-icon" [src]="getStatusIcon(test.test_status)" [alt]="test.test_status">
            <span class="test-name">{{ test.test_label }}</span>
            <div class="test-actions">
              <button class="more-vert-btn" (click)="toggleTestMenu(test.test_id, $event)">
                <img src="assets/icons/playground/more_vert.svg" alt="more_vert">
              </button>
            </div>
            <!-- Test Menu Dropdown - moved outside test-actions -->
            <div class="test-menu" *ngIf="openTestMenuId() === test.test_id" (click)="$event.stopPropagation()">
              <div class="menu-item" (click)="rerunTest(test.test_id)">
                <img src="assets/icons/playground/rerun_test.svg" alt="rerun">
                <span>Rerun Test</span>
              </div>
              <div class="menu-item delete" (click)="deleteTest(test.test_id)">
                <img src="assets/icons/playground/delete_test.svg" alt="delete">
                <span>Delete Test</span>
              </div>
            </div>
          </div>
          <div class="info">
            <span class="timestamp" *ngIf="test.test_timestamp">
              {{ test.test_timestamp | utcDateTime }}
            </span>
            <span class="test-status" *ngIf="test.test_status !== 'processed'"
              [style.color]="getStatusColor(test.test_status)">
              {{ getStatusText(test.test_status) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Test Form Overlay -->
<app-playground-test-form *ngIf="showTestForm()"
  (testFormClosed)="onTestFormClosed()"
  (testCreated)="onTestCreated($event)">
</app-playground-test-form>
